import { DEFAULT_ACCOUNT_MODAL_CALLER_IDENTIFIER } from '../../../constants/modalNames';

export default {
  modals: [],
  currentModal: null,
  createAccountDetails: {
    callerIdentifier: DEFAULT_ACCOUNT_MODAL_CALLER_IDENTIFIER
  }
};
